import React from "react";
import { InlineDatePicker } from "material-ui-pickers/DatePicker";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core";

const materialTheme = createMuiTheme({
  overrides: {
    MuiPickersToolbar: {
      toolbar: {
        backgroundColor: "#43a047",
      },
    },
    MuiPickersCalendarHeader: {
      switchHeader: {
        // backgroundColor: '#43a047',
        // color: 'white',
      },
    },
    MuiPickersYear: {
      Year: {
        color: "#43a047",
      },
      selected: {
        color: "#43a047",
      },
    },
    MuiPickersDay: {
      day: {
        // color: '#43a047',
      },
      selected: {
        backgroundColor: "#43a047",
        "&:hover": {
          backgroundColor: "#43a047",
        },
      },
      current: {
        color: "#43a047",
      },
    },
    MuiPickersModal: {
      dialogAction: {
        color: "#43a047",
      },
    },
  },
});

const inlineDatePicker = (props) => {
  const { Date, handleDateChange, label, minDate, maxDate, ...rest } = props;
  return (
    <MuiThemeProvider theme={materialTheme}>
      <InlineDatePicker
        keyboard
        variant="outlined"
        label={label ? label : "Date"}
        value={Date}
        onChange={handleDateChange}
        format="DD/MM/YYYY"
        mask={[/\d/, /\d/, "/", /\d/, /\d/, "/", /\d/, /\d/, /\d/, /\d/]}
        minDate={minDate}
        maxDate={maxDate}
        {...rest}
      />
    </MuiThemeProvider>
  );
};

export default inlineDatePicker;



// WEBPACK FOOTER //
// ./src/utils/InlineDatePicker.js